var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-pull-refresh',{attrs:{"loosing-text":_vm.$t('pullRefresh.loosingText'),"pulling-text":_vm.$t('pullRefresh.pullingText'),"loading-text":_vm.$t('pullRefresh.loadingText')},on:{"refresh":_vm.onRefresh},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }